import { DateTime } from "luxon";

export default function (basicType, definedType) {
  let dateShortcuts = [];

  switch (basicType) {
    case "transaction":
      Array.from({ length: 3 }).forEach(function (v, i) {
        let source = DateTime.now().minus({ year: i });

        dateShortcuts.push({
          title: source.toFormat("yyyy"),
          startDate: source.startOf("year").toJSDate(),
          endDate: source.endOf("year").toJSDate(),
        });
      });

      Array.from({ length: 3 }).forEach(function (v, i) {
        const thisYear = parseInt(DateTime.now().toFormat("yyyy"));

        let start = DateTime.fromObject({
          year: thisYear - (i + 1),
          month: 7,
          day: 1,
        });
        let end = DateTime.fromObject({
          year: thisYear - i,
          month: 6,
          day: 30,
        });

        dateShortcuts.push({
          title: `FY ${start.toFormat("yyyy")}/${end.toFormat("yyyy")}`,
          startDate: start.toJSDate(),
          endDate: end.toJSDate(),
        });
      });

      break;
    case "checkin":
      dateShortcuts.push({
        title: "Today",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().endOf("day").toJSDate(),
      });

      dateShortcuts.push({
        title: "This week",
        endDate: DateTime.now().endOf("day").toJSDate(),
        startDate: DateTime.now().minus({ days: 7 }).toJSDate(),
      });

      break;
    case "assignment":
      dateShortcuts.push({
        title: "Today",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().endOf("day").toJSDate(),
      });

      dateShortcuts.push({
        title: "Next 7 days",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().plus({ days: 7 }).toJSDate(),
      });

      dateShortcuts.push({
        title: "Next 30 days",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().plus({ months: 1 }).toJSDate(),
      });

      dateShortcuts.push({
        title: "Next 3 months",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().plus({ months: 3 }).toJSDate(),
      });

      break;
    case "event":
    case "runsheet":
      dateShortcuts.push({
        title: "Today",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().endOf("day").toJSDate(),
      });

      dateShortcuts.push({
        title: "Future",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().plus({ months: 6 }).toJSDate(),
      });

      dateShortcuts.push({
        title: "Past",
        endDate: DateTime.now().startOf("day").toJSDate(),
        startDate: DateTime.now().minus({ months: 6 }).toJSDate(),
      });

      dateShortcuts.push({
        title: "Next 14 days",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().plus({ days: 14 }).toJSDate(),
      });

      dateShortcuts.push({
        title: "Last 14 days",
        endDate: DateTime.now().endOf("day").toJSDate(),
        startDate: DateTime.now().minus({ days: 14 }).toJSDate(),
      });

      dateShortcuts.push({
        title: "Last Month",
        startDate: DateTime.now()
          .minus({ months: 1 })
          .startOf("month")
          .toJSDate(),
        endDate: DateTime.now().minus({ months: 1 }).endOf("month").toJSDate(),
      });

      break;

    case "comment":
      dateShortcuts.push({
        title: "Today",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().endOf("day").toJSDate(),
      });

      dateShortcuts.push({
        title: "This week",
        startDate: DateTime.now().startOf("week").toJSDate(),
        endDate: DateTime.now().endOf("week").toJSDate(),
      });
    case "log":
      dateShortcuts.push({
        title: "Today",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().endOf("day").toJSDate(),
      });

      dateShortcuts.push({
        title: "Past 5 minutes",
        startDate: DateTime.now().minus({ minutes: 5 }).toJSDate(),
        endDate: DateTime.now().toJSDate(),
      });

      dateShortcuts.push({
        title: "Past 12 Hours",
        startDate: DateTime.now().minus({ hours: 12 }).toJSDate(),
        endDate: DateTime.now().toJSDate(),
      });

      dateShortcuts.push({
        title: "Past 7 Days",
        startDate: DateTime.now().minus({ days: 7 }).toJSDate(),
        endDate: DateTime.now().toJSDate(),
      });

      break;
    case "email":
      dateShortcuts.push({
        title: "Today",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().endOf("day").toJSDate(),
      });

      dateShortcuts.push({
        title: "This week",
        startDate: DateTime.now().startOf("week").toJSDate(),
        endDate: DateTime.now().endOf("week").toJSDate(),
      });
      break;
    case "submission":
      dateShortcuts.push({
        title: "Today",
        startDate: DateTime.now().startOf("day").toJSDate(),
        endDate: DateTime.now().endOf("day").toJSDate(),
      });

      dateShortcuts.push({
        title: "This week",
        startDate: DateTime.now().startOf("week").toJSDate(),
        endDate: DateTime.now().endOf("week").toJSDate(),
      });

      dateShortcuts.push({
        title: "Past 30 days",
        startDate: DateTime.now().minus({ days: 30 }).toJSDate(),
        endDate: DateTime.now().plus({ hours: 1 }).toJSDate(),
      });

      dateShortcuts.push({
        title: "Past year",
        startDate: DateTime.now().minus({ years: 1 }).toJSDate(),
        endDate: DateTime.now().plus({ hours: 1 }).toJSDate(),
      });
      break;
    case "systemtask":
      dateShortcuts.push({
        title: "Past 5 minutes",
        startDate: DateTime.now().minus({ minutes: 5 }).toJSDate(),
        endDate: DateTime.now().toJSDate(),
      });

      dateShortcuts.push({
        title: "Past hour",
        startDate: DateTime.now().minus({ hours: 1 }).toJSDate(),
        endDate: DateTime.now().toJSDate(),
      });

      dateShortcuts.push({
        title: "Past day",
        startDate: DateTime.now().minus({ days: 1 }).toJSDate(),
        endDate: DateTime.now().toJSDate(),
      });

      break;
    case "campaign":
      Array.from({ length: 5 }).forEach(function (v, i) {
        let source = DateTime.now().minus({ month: i });
        dateShortcuts.push({
          title: source.toFormat("MMMM yyyy"),
          startDate: source.startOf("month").toJSDate(),
          endDate: source.endOf("month").toJSDate(),
        });
      });
      break;
    case "image":
      dateShortcuts.push({
        title: "This week",
        startDate: DateTime.now().startOf("week").toJSDate(),
        endDate: DateTime.now().endOf("week").toJSDate(),
      });

      Array.from({ length: 5 }).forEach(function (v, i) {
        let source = DateTime.now().minus({ month: i });

        dateShortcuts.push({
          title: source.toFormat("MMMM yyyy"),
          startDate: source.startOf("month").toJSDate(),
          endDate: source.endOf("month").toJSDate(),
        });
      });

      break;
  }

  return dateShortcuts;
}
